import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';

const WallLite: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 2, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          WallLite
        </Typography>
        <Box sx={{ width: '100%', height: '200px', bgcolor: 'grey.200', borderRadius: 1 }}>
          {/* Wall visualization content will go here */}
          <Typography variant="body2" sx={{ p: 2, color: 'text.secondary' }}>
            Wall visualization area
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default WallLite; 